import { render, staticRenderFns } from "./waterQualityMonitoring.vue?vue&type=template&id=4faddf3c&scoped=true"
import script from "./waterQualityMonitoring.vue?vue&type=script&lang=js"
export * from "./waterQualityMonitoring.vue?vue&type=script&lang=js"
import style0 from "./waterQualityMonitoring.vue?vue&type=style&index=0&id=4faddf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faddf3c",
  null
  
)

export default component.exports